export default __webpack_public_path__ + "static/image-59-75bf165ce64d2b42fd48ea515cd46b83.jpg";